<template>
    <div v-html="text" :class="[alignTextClass, classes.wrapper]">
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    text: string,
    alignText: string,
    classes?: {
        wrapper?: string
    }
}

const props = withDefaults(defineProps<Props>(), {
    text: 'Default Small Text (do change me)',
    alignText: 'left',
    classes: () => ({
        wrapper: 'small-text-wrapper wysiwyg',
    })
});

// computed
const alignTextClass = computed(() => {
    if (props.alignText === 'center') {
        return 'text-center';
    } else {
        return 'text-start';
    }
})

</script>